export enum OnboardingCategoriesStepPageTestId {
    DeprecatedCategoryList = 'OnboardingCategoriesStepPageTestId.DeprecatedCategoryList',
    CategoryList = 'OnboardingCategoriesStepPageTestId.CategoryList',
    Continue = 'OnboardingCategoriesStepPageTestId.Continue',
    DeprecatedCategoryBox = 'OnboardingCategoriesStepPageTestId.DeprecatedCategoryBox',
}

export enum OnboardingWellnessSurveyPageTestId {
    Header = 'OnboardingWellnessSurveyPageTestId.Header',
}

export enum PickYourTypeOfCarePageTestID {
    ImNotSure = 'PickYourTypeOfCarePage.ImNotSure',
    Continue = 'PickYourTypeOfCarePage.Continue',
    ONE_ON_ONE = 'PickYourTypeOfCarePage.ONE_ON_ONE',
    ON_MY_OWN = 'PickYourTypeOfCarePage.OnMyOwn',
    WithASmallGroup = 'PickYourTypeOfCarePage.WithASmallGroup',
}
